import {BackgroundTaskId} from "platformed-client/types";
import api from "../../api";
import {HTTPError} from "platformed-client";
import {param, typedQuery} from "../typing";

export const backgroundTask = typedQuery(
  ["backgroundTask", param<BackgroundTaskId>("backgroundTaskId")],
  async backgroundTaskId => {
    try {
      return await api.backgroundTasks.get(backgroundTaskId);
    } catch (ex) {
      if (ex instanceof HTTPError && ex.response.status === 404) {
        // Task is complete
        return null;
      }
      throw ex;
    }
  },
);
